// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class EntitlmentProductDefinition {
    IsAllowDataSourceForInstrument(instrument) {
        if (!this.IsDataSource) {
            return false;
        }
        if (instrument == null) {
            return false;
        }
        return this.IsExistDefinition(instrument.Id, instrument.TypeId, instrument.TradingExchange);
    }
    IsExistDefinition(instrumentId, instrumentGroupId, tradingExchange) {
        const instId = parseInt(instrumentId);
        switch (this.Type) {
            case BasisType.Instrument:
                if (isNaN(instId)) {
                    return false;
                }
                return this.InstrumentIds.includes(instId);
            case BasisType.InstrumentGroup:
                return this.InstrumentGroups.includes(instrumentGroupId);
            case BasisType.TradingExchange:
                return this.TradingExchanges.includes(tradingExchange);
            default:
                return false;
        }
    }
}
export var BasisType;
(function (BasisType) {
    BasisType[BasisType["TradingExchange"] = 0] = "TradingExchange";
    BasisType[BasisType["InstrumentGroup"] = 1] = "InstrumentGroup";
    BasisType[BasisType["Instrument"] = 2] = "Instrument";
})(BasisType || (BasisType = {}));
